import { errorTwoSvgData } from '../../../../Data/OtherPage/OtherPage'
import CommonError from '../Common/CommonError'

const Error401Container = () => {
  return (
    <CommonError errorSvg={errorTwoSvgData} />
  )
}

export default Error401Container